import type { TModernShadow } from '@modern/theme/modern-theme.types';

export const shadowBaseTheme: TModernShadow = {
  dialog: '0 1.875rem 5.625rem rgba(0, 0, 0, 0.6)',
  menu: '0 0.875rem 2.5rem rgba(0, 0, 0, 0.55)',
  toast: '0 0.75rem 2.125rem rgba(0, 0, 0, 0.5)',
  tooltip: '0 0.75rem 2rem rgba(0, 0, 0, 0.6)',
};
